import {isEmpty, isFunction} from 'lodash-es';

let debugMode = false;

export interface WootricSettings {
    account_token?: string;
    event_name?: string;
    [key: string]: unknown;
}

export interface InitParams {
    accountToken: string;
    settings?: Partial<WootricSettings>;
    debug?: boolean;
    forceSurvey?: boolean;
}

export interface SetSettingsParams {
    settings: Partial<WootricSettings>;
    override?: boolean;
}

declare global {
    interface Window {
        wootricSettings?: WootricSettings;
        wootric_survey_immediately?: boolean;
        wootric_no_surveyed_cookie?: boolean;
        wootric?: (command: string) => void;
    }
}

const WootricUtils = {
    init({
        accountToken,
        settings = {},
        debug = false,
        forceSurvey = false,
    }: InitParams): void {
        if (isEmpty(accountToken)) {
            throw new Error(`Missing required argument "accountToken".`);
        }

        if (!debug) {
            /* eslint-disable camelcase */
            window.wootricSettings = {
                ...settings,
                account_token: accountToken,
                event_name: 'default',
            };

            window.wootric_survey_immediately = forceSurvey;
            window.wootric_no_surveyed_cookie = forceSurvey;
            /* eslint-enable camelcase */
        } else {
            debugMode = true;
        }
    },

    setSettings({settings = {}, override = false}: SetSettingsParams): void {
        if (isEmpty(settings)) {
            throw new Error(`Missing required argument "settings".`);
        }

        if (override && !settings.account_token) {
            throw new Error(
                `Action Forbidden - "account_token" would be deleted.`
            );
        }

        if (!debugMode) {
            const baseSettings = override ? {} : window.wootricSettings || {};

            window.wootricSettings = {
                ...baseSettings,
                ...settings,
            };
        } else {
            // eslint-disable-next-line no-console
            console.log(
                'Wootric - Set Settings: ',
                settings,
                ', Override: ',
                override
            );
        }
    },

    runSurvey(): void {
        if (!debugMode) {
            if (!isFunction(window.wootric)) {
                return;
            }

            window.wootric('run');
        } else {
            // eslint-disable-next-line no-console
            console.log('Wootric - Run Survey');
        }
    },
};

export default WootricUtils;
